module.exports = __webpack_public_path__ + "img/collect.9c58bd38.svg";